export default __webpack_public_path__ + "static/media/wolf.4ec68937.png";